import { useMutation } from '@tanstack/react-query';
import { aiConstantsApi } from '../../AIConstantsApi';
import type { AIConstantUpdateRequest } from '../../types';
import { MutationKey } from '@shared/config';

export const useUpdateAiConstant = (id: number) => {
  return useMutation({
    mutationKey: [MutationKey.UPDATE_AI_CONSTANT, id],
    mutationFn: (data: AIConstantUpdateRequest) =>
      aiConstantsApi.updateAiConstant(id, data),
  });
};
